import { em } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useMemo } from "react";

export default function useBreakPoint(breakpoint: "sm" | "md" | "lg" | "xl") {
  const breakPointValue = useMemo(() => {
    switch (breakpoint) {
      case "sm":
        return 640;
      case "md":
        return 768;
      case "lg":
        return 1024;
      case "xl":
      default:
        return 1280;
    }
  }, [breakpoint]);
  const isMatch = useMediaQuery(`(max-width: ${em(breakPointValue)})`);

  return isMatch;
}
